import { createSlice } from '@reduxjs/toolkit'

const tabsSlice = createSlice({
  name: 'tabs',
  initialState: { open: [], activeId: null },
  reducers: {
    openTab: (state, { payload: { id, formType, label, recordId } }) => {
      if (state.open.find(t => t.id === id)) {
        state.activeId = id        // just focus existing tab
        return
      }
      if (state.open.length >= 8) return  // hard cap

      state.open.push({ id, formType, label, recordId, isDirty: false })
      state.activeId = id
    },
    closeTab: (state, { payload: id }) => {
      const idx = state.open.findIndex(t => t.id === id)
      if (idx === -1) return
      state.open.splice(idx, 1)
      if (state.activeId === id)
        state.activeId = state.open[Math.max(0, idx - 1)]?.id ?? null
    },
    setActiveTab:  (state, { payload: id }) => { state.activeId = id },
    markDirty:     (state, { payload: id }) => { const t = state.open.find(t=>t.id===id); if(t) t.isDirty=true },
    markClean:     (state, { payload: id }) => { const t = state.open.find(t=>t.id===id); if(t) t.isDirty=false },
    closeAllTabs:  (state) => { state.open = []; state.activeId = null },
  },
})

export const { openTab, closeTab, setActiveTab, markDirty, markClean, closeAllTabs } = tabsSlice.actions
export const selectTabs       = s => s.tabs.open
export const selectActiveTabId = s => s.tabs.activeId
export const selectActiveTab  = s => s.tabs.open.find(t => t.id === s.tabs.activeId)
export default tabsSlice.reducer